<div class="category-management-container" (click)="closeActionMenu()">
  <!-- Ngx UI Loader -->
  <ngx-ui-loader [hasProgressBar]="false" fgsColor="#3E916C"></ngx-ui-loader>
  
  <!-- Success Notification (Top Right) -->
  <div *ngIf="successMessage" class="success-notification">
    <svg class="success-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#10b981"/>
      <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="success-notification-message">{{ successMessage }}</span>
  </div>

  <!-- Error Notification (Top Right) -->
  <div *ngIf="errorMessage" class="error-notification">
    <svg class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="error-notification-message">{{ errorMessage }}</span>
  </div>

  <div class="page-header">
    <h2>Product Category</h2>
    <button class="btn btn-primary" (click)="openAddForm()" *ngIf="!showAddForm">
      Add Product Category
    </button>
  </div>

  <!-- Search and Filters -->
  <div class="filters-bar">
    <div class="search-box">
      <input type="text" class="search-input" placeholder="Search by Category Name, ID" [(ngModel)]="searchTerm" (input)="onSearch()">
      <span class="search-icon">🔍</span>
    </div>
    <select class="filter-select" [(ngModel)]="selectedStatus" (change)="applyFilters()">
      <option value="">Filter by Status</option>
      <option value="Active">Active</option>
      <option value="Inactive">Inactive</option>
    </select>
    <button type="button" class="btn btn-reset" (click)="resetFilters()">Reset</button>
  </div>

  <!-- Add/Edit Category Modal -->
  <div class="modal-overlay" *ngIf="showAddForm">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ editingCategory ? 'Edit' : 'Add' }} Product Category</h3>
        <button type="button" class="modal-close" (click)="cancelEdit()">&times;</button>
      </div>
      <form (ngSubmit)="saveCategory()">
        <div class="form-row">
          <div class="form-group">
            <label>Category Name<span class="required-asterisk">*</span></label>
            <input type="text" 
                   class="form-control" 
                   [class.error]="formErrors.name && formSubmitted"
                   [(ngModel)]="categoryForm.name" 
                   name="name" 
                   placeholder="Enter Category Name" 
                   (input)="clearFieldError('name')"
                   required>
            <div class="error-message" *ngIf="formErrors.name && formSubmitted">{{ formErrors.name }}</div>
          </div>
          <div class="form-group">
            <label>Upload Image<span class="required-asterisk">*</span></label>
            <div class="image-upload-container">
              <div class="file-input-wrapper">
                <input type="file" #fileInput class="file-input" accept="image/jpeg,image/jpg,image/png" (change)="onImageSelected($event)" style="display: none;">
                <input type="text" 
                       class="form-control file-display" 
                       [class.error]="formErrors.image && formSubmitted"
                       [value]="selectedImageFile?.name || 'Select File'" 
                       placeholder="Select File" 
                       readonly 
                       (click)="fileInput.click()">
                <button type="button" class="btn btn-upload" (click)="fileInput.click(); $event.preventDefault()">Upload</button>
              </div>
              <small class="file-hint">(File format either jpg, jpeg or png. Max file size 10 MB)</small>
              <div class="upload-status" *ngIf="imageUploading">
                <span class="uploading-text">Uploading image...</span>
              </div>
              <div class="upload-error" *ngIf="imageUploadError">
                <span class="error-text">{{ imageUploadError }}</span>
              </div>
              <div class="upload-success" *ngIf="uploadedImageUrl && !imageUploading && !imageUploadError">
                <span class="success-text">✓ Image uploaded successfully</span>
              </div>
              <div class="error-message" *ngIf="formErrors.image && formSubmitted && !imageUploading && !imageUploadError">
                {{ formErrors.image }}
              </div>
              <div class="image-preview-container" *ngIf="imagePreview">
                <img [src]="imagePreview" alt="Preview" class="image-preview">
                <button type="button" class="btn-remove-image" (click)="removeImage()">×</button>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Description<span class="required-asterisk">*</span></label>
          <textarea class="form-control" 
                    [class.error]="formErrors.description && formSubmitted"
                    [(ngModel)]="categoryForm.description" 
                    name="description" 
                    placeholder="Enter Description" 
                    rows="3" 
                    (input)="clearFieldError('description')"
                    required></textarea>
          <div class="error-message" *ngIf="formErrors.description && formSubmitted">{{ formErrors.description }}</div>
        </div>
        <div class="form-group">
          <label>Select Suppliers</label>
          <div class="custom-dropdown-container" (click)="$event.stopPropagation()">
            <!-- Search input field - always visible -->
            <div class="supplier-search-wrapper">
              <input 
                type="text" 
                class="supplier-search-input" 
                placeholder="Search and Select supplier"
                [ngModel]="supplierSearchTerm"
                (ngModelChange)="supplierSearchTerm = $event; onSupplierSearch($event)"
                (input)="onSupplierSearchInput($event)"
                (focus)="openSupplierDropdown()"
                (click)="openSupplierDropdown(); $event.stopPropagation()"
                autocomplete="off"
                spellcheck="false"
                #searchInput>
              <svg class="dropdown-arrow" [class.open]="showSupplierDropdown" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 6L8 10L12 6" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <!-- Dropdown menu with supplier list -->
            <div class="custom-dropdown-menu" *ngIf="showSupplierDropdown" (click)="$event.stopPropagation()">
              <div class="dropdown-list" (click)="$event.stopPropagation()">
                <!-- Show suppliers if found -->
                <div 
                  *ngFor="let supplier of filteredSuppliers" 
                  class="dropdown-item"
                  (click)="toggleSupplier(supplier._id); $event.stopPropagation()">
                  <input 
                    type="checkbox" 
                    [checked]="isSupplierSelected(supplier._id)"
                    (change)="toggleSupplier(supplier._id); $event.stopPropagation()"
                    (click)="$event.stopPropagation()">
                  <span class="item-label">
                    {{ supplier.companyName }}<span *ngIf="supplier.supplierId" class="item-id"> ({{ supplier.supplierId }})</span>
                  </span>
                </div>
                <!-- Show message when search has no results -->
                <div class="dropdown-empty" *ngIf="filteredSuppliers.length === 0 && supplierSearchTerm && supplierSearchTerm.trim().length > 0">
                  <div class="no-suppliers-message">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="#9ca3af" stroke-width="2"/>
                      <path d="M12 8V12M12 16H12.01" stroke="#9ca3af" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    <p>No suppliers found matching "{{ supplierSearchTerm }}"</p>
                    <small>Try searching by name, email, or supplier ID</small>
                  </div>
                </div>
                <!-- Show message when no suppliers available at all -->
                <div class="dropdown-empty" *ngIf="filteredSuppliers.length === 0 && (!supplierSearchTerm || !supplierSearchTerm.trim()) && suppliers.length === 0">
                  <div class="no-suppliers-message">
                    <p>No suppliers available</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Selected Suppliers Table -->
          <div class="selected-suppliers-table" *ngIf="categoryForm.suppliers.length > 0">
            <table class="suppliers-table">
              <thead>
                <tr>
                  <th>Supplier company</th>
                  <th>Supplier ID</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let supplierId of categoryForm.suppliers">
                  <td>{{ getSupplierName(supplierId) }}</td>
                  <td>{{ getSupplierId(supplierId) }}</td>
                  <td class="action-cell">
                    <button 
                      type="button" 
                      class="btn-delete-supplier"
                      (click)="removeSupplier(supplierId)"
                      title="Remove supplier">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 4L4 12M4 4L12 12" stroke="#dc2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-submit" [disabled]="formLoading">
            {{ formLoading ? (editingCategory ? 'Updating...' : 'Submitting...') : (editingCategory ? 'Update' : 'Submit') }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- View Category Modal (read-only, Admin & Procurement Manager) -->
  <div class="modal-overlay" *ngIf="showViewModal" (click)="closeViewModal()">
    <div class="modal-content view-category-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>View Product Category</h3>
        <button type="button" class="modal-close" (click)="closeViewModal()">&times;</button>
      </div>
      <div class="view-modal-body" *ngIf="viewingCategory">
        <div class="form-row">
          <div class="form-group">
            <label>Category Name</label>
            <p class="view-field-value">{{ viewingCategory.name || '—' }}</p>
          </div>
          <div class="form-group">
            <label>Image</label>
            <div class="view-image-container">
              <div class="image-placeholder view-image-placeholder" *ngIf="!viewingCategory.imageUrl">
                <svg width="60" height="60" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="40" height="40" fill="#e5e7eb"/>
                  <path d="M20 12L25 18H15L20 12Z" fill="#9ca3af"/>
                  <rect x="10" y="20" width="20" height="12" fill="#9ca3af"/>
                </svg>
                <span class="no-image-text">No image</span>
              </div>
              <img *ngIf="viewingCategory.imageUrl" [src]="viewingCategory.imageUrl" alt="{{ viewingCategory.name }}" class="view-image-thumb" (error)="onImageError($event)">
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Description</label>
          <p class="view-field-value view-description">{{ viewingCategory.description || '—' }}</p>
        </div>
        <div class="form-group">
          <label>Suppliers</label>
          <div class="view-suppliers-table-wrapper" *ngIf="getViewSupplierList().length > 0">
            <table class="suppliers-table">
              <thead>
                <tr>
                  <th>Supplier company</th>
                  <th>Supplier ID</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of getViewSupplierList()">
                  <td>{{ row.companyName }}</td>
                  <td>{{ row.supplierId }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="view-field-value no-suppliers" *ngIf="getViewSupplierList().length === 0">No suppliers linked</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-submit" (click)="closeViewModal()">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Categories Table -->
  <div class="table-container" #tableContainer *ngIf="!loading && filteredCategories.length > 0">
    <table class="category-table">
      <thead>
        <tr>
          <th>Category ID</th>
          <th>Category</th>
          <th>Description</th>
          <th>Status</th>
          <th>Image</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let category of filteredCategories">
          <td>{{ getCategoryId(category) }}</td>
          <td>{{ category.name }}</td>
          <td>{{ category.description || category.name }}</td>
          <td>
            <span class="status-badge" *ngIf="category?.status!='Deleted'"[ngClass]="category.isActive ? 'status-active' : 'status-inactive'">
              {{ category.isActive ? 'Active' : 'Inactive' }}
            </span>
            <span class="status-badge" *ngIf="category?.status==='Deleted'"[ngClass]="category.status=='Deleted' ? 'status-inactive' : 'status-active' ">
              {{ category?.status}}
            </span>
          </td>
          <td class="image-cell">
            <div class="image-placeholder" *ngIf="!getImageUrl(category.image) && !category.imageUrl">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" fill="#e5e7eb"/>
                <path d="M20 12L25 18H15L20 12Z" fill="#9ca3af"/>
                <rect x="10" y="20" width="20" height="12" fill="#9ca3af"/>
              </svg>
            </div>
            <img *ngIf="category.imageUrl || category.image" 
                 [src]="category.imageUrl || getImageUrl(category.image)" 
                 alt="{{ category.name }}" 
                 class="category-image"
                 (error)="onImageError($event)">
            <div class="image-placeholder" *ngIf="category.imageUrl || category.image" style="display: none;">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" fill="#e5e7eb"/>
                <path d="M20 12L25 18H15L20 12Z" fill="#9ca3af"/>
                <rect x="10" y="20" width="20" height="12" fill="#9ca3af"/>
              </svg>
            </div>
          </td>
          <td>
            <div class="actions-cell" *ngIf="category?.status!=='Deleted'">
              <div class="action-menu" (click)="toggleActionMenu(getCategoryActionKey(category), $event); $event.stopPropagation()">
                <span class="dots-icon" title="More actions">⋮</span>
                <div class="action-dropdown" *ngIf="showActionMenu[getCategoryActionKey(category)]" (click)="$event.stopPropagation(); $event.preventDefault()">
                  <a href="#" class="dropdown-item" *ngIf="canViewCategory()" (click)="viewCategory(category); $event.preventDefault(); $event.stopPropagation()">
                    View
                  </a>
                  <a href="#" class="dropdown-item" (click)="editCategory(category); $event.preventDefault(); $event.stopPropagation()">
                    Edit
                  </a>
                  <!-- Deactivate/Activate: Admin and Procurement Manager -->
                  <a href="#" class="dropdown-item deactivate" *ngIf="category.isActive && (authService.isAdmin() || authService.isManager())" (click)="toggleCategoryStatus(category, $event)">
                    Deactivate
                  </a>
                  <a href="#" class="dropdown-item activate" *ngIf="!category.isActive && (authService.isAdmin() || authService.isManager())" (click)="toggleCategoryStatus(category, $event)">
                    Activate
                  </a>
                  <!-- Delete: Admin only -->
                  <a href="#" class="dropdown-item delete" *ngIf="authService.isAdmin()" (click)="deleteCategory(category._id); $event.preventDefault(); $event.stopPropagation()">
                    Delete
                  </a>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    
    <!-- Infinite Scroll Loading Indicator -->
    <div class="infinite-scroll-loader" *ngIf="isLoadingMore">
      <div class="loader-spinner"></div>
      <span>Loading more categories...</span>
    </div>
    
    <!-- End of Data Message -->
    <div class="end-of-data" *ngIf="!hasMoreData && !loading && categories.length > 0">
      <p>No more categories to load</p>
    </div>
  </div>

  <div class="empty-state" *ngIf="!loading && filteredCategories.length === 0">
    <p>No categories found</p>
  </div>

  <div class="loading-state" *ngIf="loading">
    <p>Loading categories...</p>
  </div>

  <!-- Delete Confirmation Modal -->
  <div class="modal-overlay" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
    <div class="delete-modal-content" (click)="$event.stopPropagation()">
      <div class="delete-modal-header">
        <h3>Delete Category</h3>
        <button type="button" class="modal-close" (click)="closeDeleteModal()">&times;</button>
      </div>
      <div class="delete-modal-body">
        <p>Are you sure to delete this category ?</p>
      </div>
      <div class="delete-modal-footer">
        <button type="button" class="btn btn-no" (click)="closeDeleteModal()">No</button>
        <button type="button" class="btn btn-yes" (click)="confirmDelete()">Yes</button>
      </div>
    </div>
  </div>

  <!-- Status Change Success Modal -->
  <div class="modal-overlay" *ngIf="showStatusModal" (click)="closeStatusModal()">
    <div class="status-modal-content" (click)="$event.stopPropagation()">
      <button type="button" class="status-modal-close" (click)="closeStatusModal()">&times;</button>
      <div class="status-modal-body">
        <div class="status-icon-container">
          <svg class="status-icon" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="32" fill="#3b82f6"/>
            <path d="M20 32L28 40L44 24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="status-message">{{ statusMessage }}</p>
      </div>
    </div>
  </div>
</div>
